import { DEFAULT_PARTNER_ID, PARTNER_ID } from '#shared/partner';

export const usePartnerId = () => {
  // decode is overridden because Nuxt parses the cookie by default, turning a numeric partner id into a number
  // while SessionData declares it a string — the BFF then forwards that number to the GDS.
  return useCookie(PARTNER_ID, {
    readonly: true,
    default: () => DEFAULT_PARTNER_ID,
    decode: (value) => decodeURIComponent(value),
  });
};
